// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1snfU","question":"Question_question__t-2Pf","description":"Question_description__30Rhq"};